<template>
  <v-container fluid class="fill-height d-block">
    <div class="fill-height">
      <slot name="title" />
      <v-form
        @submit.prevent="onSubmit"
        ref="changePassword"
        class="fill-height"
      >
        <div class="password-info">
          <v-text-field
            :type="showCurrentPassword ? 'text' : 'password'"
            :placeholder="$t('auth.changePassword.form.currentPassword')"
            :rules="currentPasswordRules"
            filled
            autofocus
            v-model="currentPassword"
            class="theme-custom-input"
          >
            <template v-slot:append>
              <div
                @click="showCurrentPassword = !showCurrentPassword"
                class="show-password-append"
              >
                <v-icon
                  size="24"
                  v-if="showCurrentPassword"
                  class="cursor-pointer"
                  >$eyeShow</v-icon
                >
                <v-icon size="24" class="cursor-pointer" v-else
                  >$eyeHidden</v-icon
                >
              </div>
            </template>
          </v-text-field>

          <v-text-field
            :type="showNewPassword ? 'text' : 'password'"
            :placeholder="$t('auth.changePassword.form.newPassword')"
            :rules="newPasswordRules"
            filled
            v-model="newPassword"
            class="theme-custom-input"
          >
            <template v-slot:append>
              <div
                @click="showNewPassword = !showNewPassword"
                class="show-password-append"
              >
                <v-icon size="24" v-if="showNewPassword" class="cursor-pointer"
                  >$eyeShow</v-icon
                >
                <v-icon size="24" class="cursor-pointer" v-else
                  >$eyeHidden</v-icon
                >
              </div>
            </template>
          </v-text-field>

          <v-text-field
            :type="showNewPasswordRepetition ? 'text' : 'password'"
            :placeholder="$t('auth.changePassword.form.newPasswordRepetition')"
            :rules="newPasswordRepetitionRules"
            filled
            v-model="newPasswordRepetition"
            validate-on-blur
            class="theme-custom-input"
          >
            <template v-slot:append>
              <div
                @click="showNewPasswordRepetition = !showNewPasswordRepetition"
                class="show-password-append"
              >
                <v-icon
                  size="24"
                  v-if="showNewPasswordRepetition"
                  class="cursor-pointer"
                  >$eyeShow</v-icon
                >
                <v-icon size="24" class="cursor-pointer" v-else
                  >$eyeHidden</v-icon
                >
              </div>
            </template>
          </v-text-field>

          <PasswordRegulation
            @conditionsResult="conditionsResult"
            :submission="submission"
            :password="newPassword"
          />
        </div>
        <v-card-actions class="pa-0 submit-btn">
          <v-btn
            color="primary"
            depressed
            :loading="loading"
            block
            class="py-7 px-7"
            type="submit"
            >{{ $t("auth.changePassword.form.submit") }}</v-btn
          >
        </v-card-actions>

        <slot name="back"></slot>
      </v-form>
    </div>
  </v-container>
</template>
<script>
import { authService } from "@/services";
import PasswordRegulation from "@/components/Auth/PasswordRegulation";
// import Router from "@/router";
// import { mapGetters } from "vuex";

export default {
  name: "change-password",
  components: { PasswordRegulation },
  props: [],
  data() {
    return {
      result: false,
      submission: false,
      loading: false,
      currentPassword: "",
      newPassword: "",
      newPasswordRepetition: "",
      showCurrentPassword: false,
      showNewPasswordRepetition: false,
      showNewPassword: false,
      currentPasswordRules: [
        val =>
          !!val || this.$t("auth.changePassword.form.currentPasswordNotEmpty")
      ],
      newPasswordRules: [
        val => !!val || this.$t("auth.changePassword.form.newPasswordNotEmpty")
      ],
      newPasswordRepetitionRules: [
        val =>
          !!val ||
          this.$t("auth.changePassword.form.newPasswordRepetitionNotEmpty"),
        val =>
          val === this.newPassword ||
          this.$t("auth.changePassword.form.noMatch")
      ]
    };
  },
  computed: {
    // ...mapGetters({
    //   forgetPasswordData: "Auth1/GET_OTP_TOKEN_DATA",
    // }),
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log(from.name)
  //   if (from.name !== "loginForm") {
  //     Router.go(-1);
  //   } else {
  //     next();
  //   }
  // },

  methods: {
    conditionsResult(val) {
      this.result = val;
    },
    onSubmit() {
      if (!this.$refs.changePassword.validate() && !this.result) {
        this.submission = true;
        return;
      }
      this.loading = true;
      authService
        .changePassword(
          this.newPassword,
          this.newPasswordRepetition,
          this.currentPassword
        )
        .then(() => {
          if (this.$route.name === "changePassword") {
            this.$router.replace({ name: "loginForm" });
          } else {
            this.$toast.success(
              this.$t("auth.changePassword.form.successMessage")
            );
            this.currentPassword = "";
            this.newPassword = "";
            this.newPasswordRepetition = "";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped lang="scss">
@import "ChangePassword";
</style>
